<manage-wrapper
  *ngIf="!!exhibitorStand && exhibitorStand.programId && { readOnly: readState === readStates.ReadOnly || event?.is_readonly, 
    program: programs[exhibitorStand.programId], 
    standType: standTypes[exhibitorStand.standTypeId], 
    exhibitor: exhibitors[exhibitorStand.exhibitorId] } as vars"
  [canEditMain]="readState !== readStates.ReadOnly && !event?.is_readonly"
  [entityTitle]="exhibitorStand.name"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [hideLabels]="true"
  [readOnly]="readState === readStates.ReadOnly || event?.is_readonly || false"
  [deleteTitle]="'Delete exhibitor stand: ' + exhibitorStand.name || 'Unnumbered exhibitor stand'"
  [titlePlaceholder]="'Exhibitor stand number...'"
  [backgroundColor]="'#41474F'"
  [dialogTitle]="'Manage Exhibitor Stand'"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (onDelete)="deleteExhibitorStand($event)"
  (onDuplicate)="duplicateExhibitorStand()"
  (saveTitle)="updateExhibitorStandName($event)"
>

  <ng-container *ngIf="selectedTab?.id === tabs.assets">
    <assets 
      style="display:block"
      [title]="'Exhibitor Stand Assets'"
      [titleIcon]="'PRESENTATION18'"
      [assetIds]="exhibitorStand.assetIds || []" 
      [readOnly]="vars.readOnly || readState !== readStates.Program"
      [entityHolderName]="'exhibitor stand'"
      (idsAdded)="addAssetIds($event)"
      (idRemoved)="removeAssetId($event)"
    ></assets>
  </ng-container>


  <ng-container *ngIf="selectedTab?.id === tabs.requests">
    <tip-text [type]="'important'" [head]="'Important'" [body]="'exhibitor stand requests can only be seen by users with <strong>Program</strong> permissions or in an exhibitor brief.'"></tip-text>

    <ng-container *ngIf="readState === readStates.Program">
      <title-icon style="margin-top: 20px; display: block;" [title]="'Exhibitor stand requests'" [titleIcon]="'clipboard_question18'"></title-icon>
      <div *ngIf="!requests?.length" class="empty-text">No exhibitor stand requests.</div>
      <staging-requests *ngIf="!!requests?.length" [stagingRequests]="requests"></staging-requests>

      <hr class="big-rule" style="margin: 40px 0 35px;" />

      <h3 class="receive-assets-title">Receive Exhibitor Stand Requests</h3>
      <div>Create web forms so exhibitors can supply exhibitor stand requests.</div>
      
      <div class="hint" style="margin: 10px -5px 0 0;">Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.</div>

      <staging-request class="anyone"
        [stagingRequestInfo]="eRequest[data.exhibitorStandId+'_']"
        [shareType]="'eRequest'"
        [emailGenerator]="emailGenerator.bind(this)"
        (changeStatus)="setStandItemStatus('', $event, 'eRequest')">
      </staging-request>

      <div *ngIf="!!vars.exhibitor" class="performer-assets-title">Receive exhibitor stand requests from exhibitor:</div>
      <staging-request class="performer-asset-links"
      *ngIf="!!vars.exhibitor"
        [stagingRequestInfo]="eRequest[data.exhibitorStandId+'_'+vars.exhibitor.id]" 
        [entity]="vars.exhibitor"
        [emailGenerator]="emailGenerator.bind(this)"
        [shareType]="'eRequest'"
        (changeStatus)="setStandItemStatus(vars.exhibitor.id, $event, 'eRequest')">
      </staging-request>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="(!selectedTab?.id || selectedTab?.id === tabs.details)">
    <div class="manage-pods">
      <add-manage-wrapper 
        class="narrow program"
        [hideHRule]="true" 
        [titleIcon]="'COLUMN_MULTI'" 
        [wrapperTitle]="uiService.programTerm.btn" 
        [openLabel]="vars.readOnly ? '' : 'SELECT ' + uiService.programTerm.btn_upper" 
        (open)="selectProgram($event)">
        <div class="empty-text" *ngIf="!vars.program">No {{ uiService.programTerm.btn_lower }} selected</div>
        <div class="info-content" *ngIf="!!vars.program && !!vars.program.title">{{ vars.program.title || 'Unnamed Program' }}</div>
        <div class="empty-text info-content" style="font-style: italic;" *ngIf="!!vars.program && !vars.program.title">Unnamed Program</div>
      </add-manage-wrapper>
      <add-manage-wrapper 
        class="narrow stand-size"
        [wrapperTitle]="'Stand size'"
        [titleIcon]="'STAND_SIZE_18'"
        [hideHRule]="true"
        [readOnly]="!!vars.readOnly"
        [openLabel]="vars.readOnly ? '' : 'SELECT STAND SIZE'" 
        (open)="manageStandType($event)" 
        >
        <div class="empty-text" *ngIf="!vars.standType">No stand size selected</div>
        <div class="info-content" *ngIf="!!vars.standType">{{ vars.standType.name }}</div>
      </add-manage-wrapper>
      <add-manage-wrapper class="stand-exhibitor" 
        [wrapperTitle]="'Stand Exhibitor'"
        [titleIcon]="'EXHIBITORS_18'"
        [hideHRule]="true"
        [readOnly]="!!vars.readOnly"
        [openLabel]="vars.readOnly ? '' : 'SELECT EXHIBITOR'" 
        (open)="manageStandExhibitor($event)" 
        >
        <div class="empty-text" *ngIf="!vars.exhibitor">No exhibitor selected</div>
        <ng-container *ngIf="!!vars.exhibitor"
          [ngTemplateOutlet]="exhibitorTemplate" 
          [ngTemplateOutletContext]="{mobile: false, readOnly: vars.readOnly, id: vars.exhibitor.id }"
        ></ng-container>
        <ng-container *ngIf="!!vars.exhibitor"
          [ngTemplateOutlet]="exhibitorTemplate" 
          [ngTemplateOutletContext]="{mobile: true, readOnly: vars.readOnly, id: vars.exhibitor.id }"
        ></ng-container>
      </add-manage-wrapper>
      <title-icon [title]="'Stand notes'" [titleIcon]="'event_information24'" style="margin-top: 40px;"></title-icon>
      <joi-input class="description" [disabled]="!!vars.readOnly" [italicPlaceholder]="true" [(model)]="exhibitorStand.standNotes" [type]="'textarea'" [returnable]="true" [placeholder]="'Click to add stand notes...'" (joiChange)="saveExhibitorStand()"></joi-input>
    </div>
  </ng-container>

</manage-wrapper>

<ng-template #exhibitorTemplate let-mobile="mobile" let-readOnly="readOnly" let-id="id">
  <exhibitors [ngClass]="{ mobile: mobile, fullScreen: !mobile }"
    [showBriefStatus]="true"
    [displayType]="mobile ? exhibitorDisplayTypes.narrowPod : exhibitorDisplayTypes.widePod"
    [readOnly]="readOnly"
    [fromStandsId]="id"
    (deleteExhibitor)="deleteFromStand($event)"
  ></exhibitors>
</ng-template>

